import React from "react";
import "./styles.scss";

const CircularProgressBar = ({
  percentage,
  progressBarClassess,
  linecap = "square",
  label,
  strokeWidth = 13,
  size = 137,
}) => {
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;
  return (
    <div className="circular-progress-bar-container">
      <div className={`circular-progress-bar ${progressBarClassess}`}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          <circle
            className="circular-bg"
            strokeWidth={strokeWidth}
            fill="transparent"
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
          <circle
            className="circular-progress"
            strokeWidth={strokeWidth}
            fill="transparent"
            r={radius}
            cx={size / 2}
            cy={size / 2}
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: offset,
              transition: "stroke-dashoffset 0.5s ease-in-out",
            }}
            strokeLinecap={linecap}
          />
        </svg>
        <div className="circular-text">
          <span className="percentage">{percentage}%</span>
          {label ? <span className="status">{label}</span> : null}
        </div>
      </div>
    </div>
  );
};

export default CircularProgressBar;
